import type { SVGProps } from 'react';
const SvgFreeBreakfast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#free_breakfast_svg__a)">
      <path
        fill="currentColor"
        d="M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 0 0 2-2V5c0-1.11-.89-2-2-2Zm0 5h-2V5h2v3ZM4 19h16v2H4v-2Z"
      />
    </g>
    <defs>
      <clipPath id="free_breakfast_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFreeBreakfast;
